export enum Roles {
  ADMIN_XTM = 'ROLE_XTM_ADMIN',
  ADMIN_CLIENT = 'ROLE_CLIENT_ADMIN',
  USER = 'USER',
}
